import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sectors'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'sectors_wrapper',
          meta: { permissions: ['administrator', 'agent'] },
          redirect: to => ({ name: 'sectors_list', params: to.params }),
        },
        {
          path: 'list',
          name: 'sectors_list',
          meta: { permissions: ['administrator', 'agent'] },
          component: Index,
        },
      ],
    },
  ],
};
